<script setup lang="ts">
import SideBar from '@/components/layout/SideBar.vue'
</script>

<template>
  <div class="flex h-screen w-full bg-[#F8FAFC]">
    
    <SideBar class="shrink-0" />

    <div class="flex-1 flex flex-col h-full overflow-y-auto overflow-x-hidden">
      <main class="w-full flex-1">
        <slot />
      </main>
    </div>

  </div>
</template>